import qs from 'querystring'
import request from '@/utils/request'
import { API_PREFIX } from '@/utils/constants'

/**
 * @api /api/v1.Staff/staffList
 * @method GET
 * @description 获取职员列表
 *
 * @param {number} page 页码
 * @param {number} total 每页记录数
 * @param {string} search 职员搜索关键字
 *
 */
export async function find(params) {
  try {
    const query = {
      page: params.page,
      total: params.pageSize,
    }
    if (params.keyword) {
      query.search = params.keyword
    }
    const qstr = qs.stringify(query)
    const res = await request.get(`${API_PREFIX}/api/v1.Staff/staffList?${qstr}`)
    const paginate = res.data.page
    const list = res.data.data
    return {
      page: paginate.current_page,
      pageSize: paginate.per_page,
      total: paginate.total,
      totalPages: paginate.last_page,
      results: list.map((item, index) => ({
        index: (paginate.current_page - 1) * paginate.per_page + index + 1,
        id: item.id,
        username: item.userName,
        name: item.name,
        mobilePhone: item.mobile,
        wechatCertified: item.UnionID,
        resigned: item.leave,
        department:item.department,
        role:item.role
      })),
    }
  } catch (e) {
    return {
      page: params.page,
      pageSize: params.pageSize,
      total: 0,
      totalPages: 1,
      results: [],
    }
  }
}

/**
 * @api /api/v1.Staff/staffDetail
 * @method GET
 * @description 获取用户详情
 *
 * @param {number} id 用户 ID
 *
 */
export async function get(params) {
  try {
    const query = {
      id: params.id,
    }
    const qstr = qs.stringify(query)
    const res = await request.get(`${API_PREFIX}/api/v1.Staff/staffDetail?${qstr}`)
    const data = res.data
    const userInfo = data.userInfo
    return {
      id: userInfo.id,
      name: userInfo.name,
      mobilePhone: userInfo.mobile,
      resigned: !!userInfo.leave,
      roles: data.position,
      departments: data.department,
      note: userInfo.desc,
    }
  } catch (e) {
    return null
  }
}

/**
 * @api /api/v1.Staff/addStaff
 * @method POST
 * @description 添加新用户
 *
 * @param {string} name 姓名
 * @param {string} mobile 手机号码
 * @param {number[]} position 职位 ID 数组
 * @param {number[]} department 部门 ID 数组
 * @param {string} desc 备注
 *
 */
export async function create(params) {
  try {
    const query = {
      name: params.name,
      mobile: params.mobilePhone,
      position: params.roles.map(item => item.id),
      department: params.departments.map(item => item.id),
      desc: params.note,
    }
    await request.post(`${API_PREFIX}/api/v1.Staff/addStaff`, query)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Staff/editStaff
 * @method POST
 * @description 编辑用户
 *
 * @param {number} id 用户 ID
 * @param {number} leave 是否离职，1: 离职; 0: 未离职
 * @param {number[]} position 职位 ID 数组
 * @param {number[]} department 部门 ID 数组
 * @param {string} desc 备注
 *
 */
export async function update(params) {
  try {
    const query = {
      id: params.id,
      leave: params.resigned ? 1 : 0,
      position: params.roles.map(item => item.id),
      department: params.departments.map(item => item.id),
      desc: params.note,
    }
    await request.post(`${API_PREFIX}/api/v1.Staff/editStaff`, query)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Staff/delStaffs
 * @method POST
 * @description 批量删除用户
 *
 * @param {number[]} ids 用户 ID 数组
 *
 */
export async function remove(params) {
  try {
    const query = {
      ids: params.ids,
    }
    await request.post(`${API_PREFIX}/api/v1.Staff/delStaffs`, query)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Staff/downloadUserInfoExcel
 * @method GET
 * @description 导出用户信息
 *
 */
export function getExportUrl() {
  return `${API_PREFIX}/api/v1.Staff/downloadUserInfoExcel`
}

/**
 * @api /api/v1.Staff/addStaffsByExcel
 * @method POST
 * @description 批量导入用户
 *
 * @param {FILE} file 导入文件
 *
 */
export async function importStaffs(params) {
  try {
    const fd = new FormData()
    fd.append('file', params.file, params.file.name)
    await request.post(`${API_PREFIX}/api/v1.Staff/addStaffsByExcel`, fd)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Staff/createPositionQRcode
 * @method POST
 * @description 生成岗位二维码
 *
 * @param {number[]} position 职位 ID 数组
 * @param {number[]} department 部门 ID 数组
 *
 */
export async function generateQrcode(params) {
  try {
    const query = {
      position: params.roles,
      department: params.departments,
    }
    const res = await request.post(`${API_PREFIX}/api/v1.Staff/createPositionQRcode`, query)
    return res.data.url
  } catch (e) {
    return null
  }
}
